import { css, breakpoint, palette } from 'bumbag';
import { _ as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';

var _templateObject, _templateObject2, _templateObject3;
var PageContent = {
  styles: {
    base: function base(props) {
      return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      padding: 2rem;\n\n      ", ";\n    "])), breakpoint('max-tablet', css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n          padding-left: 1rem;\n          padding-right: 1rem;\n        "]))))(props));
    }
  },
  Wrapper: {
    styles: {
      base: function base(props) {
        return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n        background-color: ", ";\n        border-bottom: 1px solid ", ";\n      "])), palette('white')(props), palette('white900')(props));
      }
    }
  }
};

export default PageContent;
